class ImageService {

  constructor(config) {
    this.config = config;
  }

  getUrl(key, params) {
    return `${this.config.host}/${key}?w=${params.width}`
  }

}

module.exports = ImageService